(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-value-bridge"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-value-bridge-reveal')) {
    customElements.define('pp-value-bridge-reveal', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-revealed')) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (this.motion.matches || !('IntersectionObserver' in window)) {
          this.reveal();
          return;
        }

        try {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) this.reveal();
          }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });

          this.onMotionChange = () => {
            if (this.motion.matches) this.reveal();
          };
          this.motion.addEventListener('change', this.onMotionChange);
          this.setAttribute('data-reveal-pending', '');
          this.observer.observe(this);
        } catch {
          // The copy must stay readable if enhancement is unavailable.
          this.reveal();
        }
      }

      reveal() {
        this.removeAttribute('data-reveal-pending');
        this.setAttribute('data-revealed', '');
        this.cleanup();
      }

      cleanup() {
        this.observer?.disconnect();
        if (this.onMotionChange) this.motion?.removeEventListener('change', this.onMotionChange);
      }

      disconnectedCallback() {
        this.cleanup();
        this.removeAttribute('data-reveal-pending');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
